import React, { useState } from "react";
import "../../pages/navbar.css";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { NOT_SUPPORTED_STATES, US_STATES } from "../../Common/States";
import { Button } from "react-bootstrap";
import { ReturnStates } from "./TaxPreparationServiceFormContext";

const StateReturnsForm:React.FC<{
  returnsState:ReturnStates, 
  index: number,
  onValueChange:(event:any, index:number) => void,
  onAdd: ()=> void,
  onRemove: (index: number) => void,
  recordsCount: number,
  paymentCompleted: boolean | undefined}> = ({returnsState, index, onValueChange, onAdd, onRemove, recordsCount, paymentCompleted}) => {
  
  const [showError, setShowError] = useState(false);

  const addHandler = () => {
    if(returnsState.State) {
      setShowError(false);
      onAdd();
    }else {
      setShowError(true);
    }
  }

  const SUPPORTED_STATES = US_STATES.filter((state) => !NOT_SUPPORTED_STATES.includes(state.abbreviation));

  
  return (
        <Form as={Row}>
          {showError && 
          <p className='fs-8 color-red'>Please fill required information in this form.</p>
          }
          <Row className="mb-3 d-flex justify-content-between">
            <Col md={3} lg={3}>
              <Form.Group as={Col} controlId="validationCustom03">
                <Form.Label>State*</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  value={returnsState.State}
                  name="State"
                  disabled={paymentCompleted}
                  onChange={(event) => onValueChange(event, index)}
                >
                  <option value="">- </option>
                  {SUPPORTED_STATES.map((state) => {
                    return (
                      <option value={state.abbreviation}>
                        {state.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please provide a valid State.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={9} lg={9} className="d-flex align-items-end px-3">
              {recordsCount === index+1 && 
              <Button variant='btn btn-primary fw-bold' disabled={paymentCompleted} onClick={addHandler}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H10.625V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375H9.375V3.125C9.375 2.95924 9.44085 2.80027 9.55806 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5C10.1658 2.5 10.3247 2.56585 10.4419 2.68306C10.5592 2.80027 10.625 2.95924 10.625 3.125V9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10Z" fill="white"/>
                </svg> Add
              </Button>
              }
              {recordsCount !== index+1 && 
              <Button variant='btn btn-danger fw-bold' disabled={paymentCompleted} onClick={() => onRemove(index)}>Remove</Button>
              }
            </Col>
            </Row>
        </Form>
  );
}

export default StateReturnsForm;
